import React, {useMemo, useState} from "react";
import {Container, Form} from "react-bootstrap";
import {ReactSelectBootstrap} from "react-select-bootstrap";
import PurposeBox from "../../Components/SalesAnalysis/PurposeBox.jsx";
import StickyFilterBlock from "../../Components/StickyFilterBlock.jsx";
import {filterZusammenfassung} from "../../Components/SalesAnalysis/format.js";
import AnalysisFilterBar from "../../Components/SalesAnalysis/AnalysisFilterBar.jsx";
import DataStatusBar from "../../Components/SalesAnalysis/DataStatusBar.jsx";
import VertreterMonatTable from "../../Components/SalesAnalysis/VertreterMonatTable.jsx";
import useAnalysisFilters from "../../Components/SalesAnalysis/useAnalysisFilters.js";
import {useQueryListState} from "../../Components/SalesAnalysis/useQueryState.js";
import {monthLabel} from "../../Components/SalesAnalysis/format.js";
import HeaderWithHelp from "../../Components/SalesAnalysis/HeaderWithHelp.jsx";

/**
 * Vertreter × Monat: zusätzlich zur gemeinsamen Filterleiste eine
 * Monatsauswahl (Standard: alle 12 Monate - Vorjahre vollständig, laufendes
 * Jahr wie überall am Stichmonat gekappt, siehe schnittstelle.md). Wählt der
 * Nutzer stattdessen einzelne Monate, gilt die Auswahl für alle Jahre
 * gleich; die Hochrechnung ergibt dann keinen Sinn mehr und wird
 * ausgeblendet (Befund A).
 */
export default function SalesAnalysisVertreterMonat() {
    const filters = useAnalysisFilters();
    const [months, setMonths] = useQueryListState("months", []);
    const [reloadToken, setReloadToken] = useState(0);

    const monthOptions = useMemo(() => {
        const max = filters.stichmonat ? Number(filters.stichmonat) : 12;
        return Array.from({length: max}, (_, i) => ({value: String(i + 1), label: monthLabel(i + 1)}));
    }, [filters.stichmonat]);
    const selectedMonths = monthOptions.filter((o) => months.includes(o.value));

    const params = {
        ...filters.params,
        months: months.length ? months.map(Number) : undefined,
        _v: reloadToken,
    };

    return (
        <Container fluid className="pt-2 pb-4">
            <PurposeBox />
            <h1 className="h4 mb-2">Vertreter × Monat</h1>
            {filters.metaError && <div className="alert alert-warning">{filters.metaError}</div>}
            {filters.filtersReady && (
                <>
                    <StickyFilterBlock summary={filterZusammenfassung(filters, [months.length ? `Monate ${months.join(", ")}` : null])}>
                        <AnalysisFilterBar filters={filters} />
                        <div className="mb-2" style={{maxWidth: 320}}>
                            <Form.Label className="small text-muted mb-1">
                                <HeaderWithHelp help="Einzelne Monate statt des gesamten Zeitraums; bei Auswahl entfällt die Hochrechnung.">
                                    Monate
                                </HeaderWithHelp>
                            </Form.Label>
                            <ReactSelectBootstrap
                                isMulti
                                placeholder="Alle Monate"
                                noOptionsMessage={() => "Kein Monat gefunden"}
                                options={monthOptions}
                                value={selectedMonths}
                                onChange={(value) => setMonths((value || []).map((o) => o.value))}
                            />
                        </div>
                        <DataStatusBar meta={filters.meta} onRecalculated={() => setReloadToken((t) => t + 1)} />
                    </StickyFilterBlock>
                    <VertreterMonatTable filters={filters} params={params} explicitMonths={months.length > 0} />
                </>
            )}
        </Container>
    );
}
